module.exports = __webpack_public_path__ + "static/media/sf-logo.7799078d.svg";